import {
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
  Image,
} from "react-native";
import React, { useRef, useState } from "react";
import { CustomButton, Dropdown } from "./index";
import { FONT_SIZE, THEME_COLORS } from "../styles";
// import {Image} from "react-native-elements";
import { FontAwesome as Icon } from "@expo/vector-icons";
interface IFilterHeaders {
  label: string;
  style: StyleProp<ViewStyle>;
  type: string;
}

interface IFilterProps {
  filterHeaders: (IFilterHeaders | any)[];
  renderFilter: any;
  filterSnippet?: any;
  onDownloadList: (filters) => void;
  onApplyFilter: (filters) => void;
  isDownloadButtonVisible?: boolean;
}

const Filters = (props: IFilterProps) => {
  const {
    filterHeaders,
    renderFilter,
    onApplyFilter,
    onDownloadList,
    filterSnippet,
    isDownloadButtonVisible,
  } = props;
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [filterState, setFilterState] = useState({});
  const ref = useRef();

  const updateFilterState = (key, value, removeKey: boolean) => {
    setFilterState((prevState) => {
      const newState = { ...prevState, [key]: value };
      if (!!removeKey && removeKey) delete newState[key];
      return newState;
    });
  };

  const getFilterValue = (key) => {
    return filterState.hasOwnProperty(key) ? filterState[key] : null;
  };

  // @ts-ignore
  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <TouchableOpacity
        ref={ref}
        style={[{ flexDirection: "row", alignItems: "center" }]}
        onPress={() => {
          setIsFilterVisible(!isFilterVisible);
        }}
      >
        <Image
          source={require("./../../assets/filter_icon.png")}
          style={{ width: 19, height: 14 }}
        />
        <View style={{ marginLeft: 15 }}>
          {!!filterSnippet ? (
            filterSnippet
          ) : (
            <Text
              style={{
                fontWeight: "bold",
                fontSize: FONT_SIZE.s1,
                marginRight: 10,
              }}
            >
              Filters
            </Text>
          )}
        </View>
      </TouchableOpacity>
      {!!filterSnippet ? (
        <TouchableOpacity
          onPress={() => {
            setFilterState({});
            onApplyFilter({});
          }}
        >
          <Icon
            name={"times-circle-o"}
            color={THEME_COLORS.redAlert}
            size={20}
          />
        </TouchableOpacity>
      ) : null}
      <Dropdown
        show={isFilterVisible}
        onClose={() => setIsFilterVisible(false)}
        parentRef={ref}
      >
        {
          <View
            style={[
              {
                flexDirection: "column",
                borderRadius: 4,
                borderColor: THEME_COLORS.primary,
                borderWidth: 1,
                backgroundColor: THEME_COLORS.bgWhite,
                padding: 10,
                width: 200,
              },
            ]}
          >
            {filterHeaders.map((obj, index) => {
              return (
                <View key={index} style={[obj.style]}>
                  <Text style={{ fontWeight: "bold", marginTop: 10 }}>
                    {obj.label}
                  </Text>
                  {renderFilter({
                    filterHeaderObj: obj,
                    filterState,
                    updateFilterState,
                    getFilterValue,
                  })}
                </View>
              );
            })}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginVertical: 10,
              }}
            >
              <CustomButton
                text={"Apply"}
                onPress={() => {
                  onApplyFilter(filterState);
                  setIsFilterVisible(false);
                }}
              />
            </View>
          </View>
        }
      </Dropdown>
      {!!isDownloadButtonVisible && isDownloadButtonVisible ? (
        <View style={{ marginLeft: 30 }}>
          <CustomButton
            text={"Download"}
            onPress={() => onDownloadList(filterState)}
          />
        </View>
      ) : (
        <></>
      )}
    </View>
  );
};

export default Filters;
